module.exports = __webpack_public_path__ + "d38025459a44f0613fb11d5a426cbcdf.png";